// extracted by mini-css-extract-plugin
export default {"panel":"panel§TU0JFFrp9p6dD1HzejVN"};